import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { CorpUIResponse } from 'src/types/Corp';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { useGetCorporate } from 'src/components/enterprise/features/Corporate/EditPage/hooks/useGetCorporate';
import { useUpdateCorporate } from 'src/components/enterprise/features/Corporate/EditPage/hooks/useUpdateCorporate';

type UseCorporateDetailsReturnType = {
  corpData: CorpUIResponse;
  corpFormValues?: CorporateFormFields;
  getCorpLoading: boolean;
  updateCorp: (values: CorporateFormFields) => Promise<void>;
  getCorpError: IErrorResponse;
};

type useCorporateEditPageProps = {
  corpId: string;
  onSuccess?: () => Promise<void>;
  onError?: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export function useCorporateEditPage({
  corpId,
  onSuccess,
  onError,
}: useCorporateEditPageProps): UseCorporateDetailsReturnType {
  const {
    corpData,
    corpFormValues,
    loading: getCorpLoading,
    error: getCorpError,
  } = useGetCorporate(corpId);
  const { updateCorp } = useUpdateCorporate({
    corpId,
    corpRawData: corpData,
    onSuccess,
    onError,
  });

  return {
    corpData,
    corpFormValues,
    getCorpLoading,
    getCorpError,
    updateCorp,
  };
}
